export class Cart {
    id_cart: number = 0;
    id_user: number = 0;
    products: ProductsCart[] = [];
    total: number = 0;
    baseCurrency: string = '';
}

export class ProductsCart{
    id_product: number = 0;
    name_product: string = "";
    price_product: number = 0;
    amount_product: number = 0;
}
